<template>
  <v-card class="cluster-detail-table rounded-xl card-bg card-bd d-flex flex-column overflow-hidden" variant="elevated"
    elevation="0">
    <template #title>
      <div class="d-flex justify-space-between align-center">
        <!-- <span>电芯详情</span> -->
        <div class="d-flex ga-2">
          <div style="width: 160px;">
            <v-select v-model="curPack" :items="packList" item-title="label" item-value="value" density="compact"
              variant="outlined" hide-details placeholder="pack编号" clearable class="filter-select"
              :menu-props="{ contentClass: 'cluster-detail-filter-select-menu' }"
              active-class="filter-select-active"></v-select>
          </div>
          <div style="width: 160px;">
            <v-select v-model="curCell" :items="cellNumberList" item-title="label" item-value="value" density="compact"
              variant="outlined" hide-details placeholder="电芯编号" clearable class="filter-select"
              :menu-props="{ contentClass: 'cluster-detail-filter-select-menu' }"
              active-class="filter-select-active"></v-select>
          </div>
        </div>
      </div>
    </template>

    <div class="d-flex flex-column flex-grow-1 overflow-hidden">
      <v-table density="default" class="bg-transparent custom-table flex-grow-1 overflow-auto">
        <thead>
          <tr>
            <th class="text-left font-weight-regular" style="color: #444a6d;">pack编号</th>
            <th class="text-left font-weight-regular" style="color: #444a6d;">电芯编号</th>
            <th class="text-left font-weight-regular" style="color: #444a6d;">电芯温度(℃)</th>
            <th class="text-left font-weight-regular" style="color: #444a6d;">电芯电压(mV)</th>
            <th class="text-left font-weight-regular" style="color: #444a6d;">电芯内阻(mΩ)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in paginedTableData" :key="index">
            <td style="color: #444a6d;">{{ item.packNumber || '--' }}</td>
            <td style="color: #444a6d;">{{ item.number }}</td>
            <td style="color: #444a6d;">{{ fmtd(item.T, 1, 1) }}</td>
            <td style="color: #444a6d;">{{ fmtd(item.U, 1, 1) }}</td>
            <td style="color: #444a6d;">{{ fmtd(item.R, 1, 2) }}</td>
          </tr>
        </tbody>
      </v-table>
      <TablePagination :total="tableData.length" :page-size="pageSize" :page-num="pageNum"
        @change="handlePageChange"/>
      <!-- <div class="pagination-container">
        <div class="pagination-info">共 {{ tableData.length }} 项数据</div>
        <div class="pagination-controls">
          <v-select v-model="pageSize" :items="pageSizeItems" variant="outlined" density="compact"
            class="page-size-select" hide-details @update:model-value="handleSizeChange" />
          <v-pagination v-model="pageNum" :length="totalPages" :total-visible="7" class="custom-pagination"
            @update:model-value="handlePageChange" />
          <div class="jump-to-page">
            <span>跳至</span>
            <v-text-field v-model.number="jumpPage" type="number" variant="outlined" density="compact"
              class="jump-input" hide-details @keyup.enter="handleJumpToPage" @blur="handleJumpToPage" />
            <span>/{{ totalPages }} 页</span>
          </div>
        </div>
      </div> -->
    </div>
  </v-card>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { fmtd } from '@/utils/index'
import TablePagination from '@/components/TablePagination/index.vue'

const props = defineProps({
  batteryData: {
    type: Object,
    default: () => ({})
  }
})

const curPack = ref(null) // null for '全部'
const curCell = ref(null)

// pack 编号列表
const packList = computed(() => {
  try {
    const list = []
    const packSize = props.batteryData.bmu?.packSize || 0 // pack 数量

    for (let i = 0; i < packSize; i++) {
      const num = String(i + 1).padStart(2, '0')
      list.push({
        label: num + ' 号',
        value: i + 1
      })
    }
    return list
  } catch (error) {
    return []
  }
})

// 电芯编号列表
const cellNumberList = computed(() => {
  try {
    const list = []
    if (!props.batteryData.bmu) return list

    let sourceList = []
    if (!curPack.value) {
      sourceList = props.batteryData.bmu.bmuList || []
    } else {
      const index = curPack.value - 1
      if (props.batteryData.bmu.bumListGroup && props.batteryData.bmu.bumListGroup[index]) {
        sourceList = props.batteryData.bmu.bumListGroup[index].cells
      }
    }

    const cellOpts = sourceList.map(item => ({
      label: item.number + ' 号',
      value: item.number
    }))

    return cellOpts
  } catch (error) {
    return []
  }
})

// 表格数据
const tableData = computed(() => {
  try {
    if (!props.batteryData.bmu) return []

    let list = []
    if (!curPack.value) {
      list = props.batteryData.bmu.bmuList || []
    } else {
      const index = curPack.value - 1
      if (props.batteryData.bmu.bumListGroup && props.batteryData.bmu.bumListGroup[index]) {
        list = props.batteryData.bmu.bumListGroup[index].cells
      }
    }

    if (curCell.value) {
      list = list.filter(it => it.number === curCell.value)
    }

    return list
  } catch (error) {
    return []
  }
})

const pageNum = ref(1)
const pageSize = ref(16)
const jumpPage = ref(1)

// 每页条数选项
const pageSizeItems = [
  { title: '10 条/页', value: 10 },
  { title: '16 条/页', value: 16 },
  { title: '20 条/页', value: 20 },
  { title: '50 条/页', value: 50 },
  { title: '100 条/页', value: 100 }
]

const totalPages = computed(() => {
  const pages = Math.ceil((tableData.value.length || 0) / pageSize.value)
  return pages === 0 ? 1 : pages
})

const paginedTableData = computed(() => {
  const start = (pageNum.value - 1) * pageSize.value
  const end = start + pageSize.value
  return tableData.value.slice(start, end)
})

// 分页变化处理
const handlePageChange = (page) => {
  pageNum.value = page
  jumpPage.value = page
}

// 每页条数变化处理
const handleSizeChange = (size) => {
  pageSize.value = size
  pageNum.value = 1
  jumpPage.value = 1
}

// 跳转到指定页
const handleJumpToPage = () => {
  if (jumpPage.value >= 1 && jumpPage.value <= totalPages.value) {
    pageNum.value = jumpPage.value
  } else {
    // 如果输入无效，重置为当前页
    jumpPage.value = pageNum.value
  }
}

watch([curPack, curCell], () => {
  pageNum.value = 1
  jumpPage.value = 1
})

watch(curPack, () => {
  curCell.value = null
})
</script>

<style scoped lang="scss">
.card-bg {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.63) 0%, rgba(255, 255, 255, 0.42) 104.73%);
}

.card-bd {
  border: 1px solid #fff;
}

.cluster-detail-table {
  height: calc(100vh - 280px);
}

.cluster-detail-filter-select-menu {
  border-radius: 10px !important;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
  margin-top: 4px !important;
  overflow: hidden !important;
  border: 1px solid rgba(224, 228, 231, 1) !important;

  .v-list {
    background: #fff !important;
    border-radius: 10px !important;
    padding: 4px 0 !important;

    .v-list-item {
      min-height: auto !important;
      padding: 8px 12px !important;
      color: rgba(46, 46, 46, 1) !important;
      font-family: 'PingFang SC', sans-serif !important;
      font-size: 13px !important;
      font-weight: 400 !important;
      line-height: 24px !important;
      transition: background-color 0.2s ease, color 0.2s ease !important;
      cursor: pointer !important;
      text-align: left !important;

      &:hover {
        background-color: #f5f7fa !important;
        color: rgba(58, 104, 255, 1) !important;
      }

      .v-list-item-title {
        font-family: 'PingFang SC', sans-serif !important;
        font-size: 13px !important;
        font-weight: 400 !important;
        color: inherit !important;
        line-height: 24px !important;
      }
    }

    // 活动项样式（使用 active-class）
    .filter-select-active,
    .v-list-item--active {
      background-color: #f5f7fa !important;
      color: rgba(58, 104, 255, 1) !important;

      .v-list-item-title {
        color: rgba(58, 104, 255, 1) !important;
      }
    }
  }
}

.custom-table {
  :deep(th) {
    font-size: 14px !important;
    height: 48px !important;
    border-bottom: 1px solid #E0E4E7 !important;
  }

  :deep(td) {
    font-size: 14px !important;
    height: 52px !important;
    border-bottom: 1px solid #E0E4E7 !important;
  }
}

// 下拉框样式
.filter-select {
  width: 160px;
  min-width: 160px;

  :deep(.v-field) {
    min-height: 40px !important;
    height: 40px !important;
    max-height: 40px !important;
    background: #fff;
    border: 1px solid rgba(192, 207, 218, 0.3);
    border-radius: 20px;
    display: flex;
    align-items: center;
    margin: 0;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  }

  :deep(.v-field__input) {
    padding: 8px 0px 8px 16px;
    font-family: "HarmonyOS Sans SC", sans-serif;
    font-size: 14px;
    display: flex;
    align-items: center;
  }

  :deep(.v-field__outline) {
    display: none;
  }

  :deep(.v-select__selection) {
    font-family: "HarmonyOS Sans SC", sans-serif;
    font-size: 14px;
    color: #2E2E2E;
    line-height: 24px;
    display: flex;
    align-items: center;
  }

  :deep(.v-field__append-inner .v-icon) {
    font-size: 16px !important;
    width: 16px !important;
    height: 16px !important;
    color: #2E2E2E !important;
    opacity: 0.22;
  }
}

:deep(.mdi-menu-down) {
  font-size: 16px !important;
  width: 16px !important;
  height: 16px !important;
  color: #2E2E2E !important;
  opacity: 0.22;
}

// 分页容器样式
.pagination-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  background: transparent;
  flex-shrink: 0;
  border-top: 1px solid #f0f0f0;

  :deep(.v-btn--disabled) {
    color: #fff !important;
    opacity: 1 !important;
  }
}

.pagination-info {
  font-family: 'PingFang SC', sans-serif;
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  line-height: 22px;
  letter-spacing: 0%;
  color: rgba(0, 0, 0, 0.6);
  vertical-align: middle;
}

.pagination-controls {
  display: flex;
  align-items: center;
  gap: 16px;
  height: 100%;
}

.page-size-select {
  width: 112px;
  flex-shrink: 0;

  :deep(.v-field) {
    background: #fff !important;
    border: 1px solid #dcdcdc !important;
    border-radius: 3px !important;
    min-height: auto !important;
    height: auto !important;
    padding: 5px 8px !important;
    box-shadow: none !important;
    display: flex !important;
    align-items: center !important;
  }

  :deep(.v-field__input) {
    padding: 0 !important;
    font-family: 'PingFang SC', sans-serif !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    color: rgba(0, 0, 0, 0.9) !important;
    min-height: auto !important;
    height: 22px !important;
    line-height: 22px !important;
    display: flex !important;
    align-items: center !important;
  }

  :deep(.v-select__selection) {
    font-family: 'PingFang SC', sans-serif !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    color: rgba(0, 0, 0, 0.9) !important;
    line-height: 22px !important;
    margin: 0 !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  :deep(.v-field__outline) {
    display: none !important;
  }

  :deep(.v-field__append-inner .v-icon) {
    font-size: 16px !important;
    width: 16px !important;
    height: 16px !important;
    color: #2E2E2E !important;
    opacity: 0.22;
  }
}

.custom-pagination {
  flex-shrink: 0;

  :deep(.v-pagination__list) {
    align-items: center;
    gap: 8px !important;
    margin: 0 !important;
  }

  :deep(.v-pagination__item--is-active) {
    color: #000000E6 !important;
    border: none !important;
    box-shadow: none !important;

    .v-btn {
      background-color: #3A68FF !important;
      color: #fff !important;
      border: none !important;

      &:hover {
        background-color: #3A68FF !important;
        color: #fff !important;
        border: none !important;
      }
    }
  }

  :deep(.v-btn) {
    min-width: 32px !important;
    width: 32px !important;
    height: 32px !important;
    border-radius: 3px !important;
    margin: 0 !important;
    font-family: 'PingFang SC', sans-serif !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    line-height: 22px !important;
    border: 1px solid #DCDCDC !important;
    background: transparent !important;
    color: #000000E6 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 0 !important;
    transition: none !important;
    box-shadow: none !important;
    text-align: center !important;

    &:hover {
      background: transparent !important;
      color: #000000E6 !important;
    }

    .v-pagination__item--text {
      line-height: 22px !important;
      font-family: 'PingFang SC', sans-serif !important;
      font-size: 14px !important;
      color: #000000E6 !important;
    }
  }

  :deep(.v-pagination__prev),
  :deep(.v-pagination__next) {
    min-width: 32px !important;
    width: 32px !important;
    height: 32px !important;
    border-radius: 3px !important;
    border: none !important;
    background: transparent !important;
    padding: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    transition: none !important;
    box-shadow: none !important;

    .v-btn {
      border: none !important;
    }

    &:hover:not(.v-pagination__item--disabled) {
      background: transparent !important;
    }

    &.v-pagination__item--disabled {
      opacity: 0.4 !important;
      cursor: not-allowed !important;
    }
  }

  :deep(.v-pagination__prev .v-icon),
  :deep(.v-pagination__next .v-icon) {
    font-size: 16px !important;
    width: 16px !important;
    height: 16px !important;
    color: rgba(0, 0, 0, 1) !important;
  }

  /* 省略号（ellipsis）样式 */
  :deep(.v-pagination__item--ellipsis) {
    border: none !important;
    background: #fff !important;
    color: #000000E6 !important;
    font-family: 'PingFang SC', sans-serif !important;
    font-size: 14px !important;
  }

  :deep(.v-btn--variant-text) {
    border: 1px solid #DCDCDC !important;
    background: transparent !important;
    color: #000000E6 !important;
    font-family: 'PingFang SC', sans-serif !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    box-shadow: none !important;

    // &:active,
    // &:focus {
    //   box-shadow: none !important;
    //   background: transparent !important;
    // }
  }
}

.jump-to-page {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'PingFang SC', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
  background: #e3e3e3;
  padding: 2px 16px;
  border-radius: 3px;
  line-height: 22px;
  height: 34px;
  width: 160px;
  flex-shrink: 0;

  span {
    white-space: nowrap;
    line-height: 22px;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.6);
  }

  .jump-input {
    flex: 1 0 0;
    min-width: 0;

    :deep(.v-field) {
      background: #fff !important;
      border: 1px solid #dcdcdc !important;
      border-radius: 3px !important;
      min-height: auto !important;
      height: auto !important;
      margin: 0 !important;
      box-shadow: none !important;
      display: flex !important;
      align-items: center !important;
    }

    :deep(.v-field__input) {
      padding: 0 !important;
      text-align: center !important;
      font-family: 'PingFang SC', sans-serif !important;
      font-size: 14px !important;
      font-weight: 400 !important;
      color: rgba(0, 0, 0, 0.9) !important;
      min-height: auto !important;
      height: 22px !important;
      line-height: 22px !important;
    }

    :deep(.v-field__outline) {
      display: none !important;
    }

    :deep(input) {
      text-align: center !important;
      padding: 0 !important;
      margin: 0 !important;
    }

    /* 隐藏数字输入框的上下箭头 */
    :deep(input[type="number"]) {

      &::-webkit-inner-spin-button,
      &::-webkit-outer-spin-button {
        -webkit-appearance: none !important;
        margin: 0 !important;
        display: none !important;
      }
    }
  }
}
</style>
